module.exports = __webpack_public_path__ + "static/plane_mock-2341fe7cd04184c0123ff5f97ed9485a.png";